module["exports"] = [
  "Sr.",
  "Sra.",
  "Sta."
];
